module.exports = __webpack_public_path__ + "static/media/add-user.ce4a8deb.svg";